"use strict";
exports.__esModule = true;
var __shared__1 = require("./__shared__");
exports["default"] = {
    styles: {
        root: Object.assign({}, __shared__1.sharedRoot, { backgroundColor: '#f8f8f8' }),
        attribute: { color: '#333' },
        unquotedAttribute: { color: '#333' },
        string: { color: '#de1044' },
        nil: { color: '#008080' },
        number: { color: '#008080' },
        boolean: { color: '#008080' },
        punctuation: { color: '#333' }
    }
};
